import { render, staticRenderFns } from "./task_allot.vue?vue&type=template&id=5e59f7c4&scoped=true"
import script from "./task_allot.vue?vue&type=script&lang=js"
export * from "./task_allot.vue?vue&type=script&lang=js"
import style0 from "./task_allot.vue?vue&type=style&index=0&id=5e59f7c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e59f7c4",
  null
  
)

export default component.exports